import React from 'react';
import { Button } from '../ui';
import DistrictFinder from './DistrictFinder';
import SearchBar from './SearchBar';
import { STATS } from '../../data/marketing';

// District-first hero. Primary action = explore your district (DistrictFinder).
// A clearly-labeled parent "Find Tickets" search stays visible as secondary.
const Hero = ({ onRequestDemo }) => {
  return (
    <section className="relative overflow-hidden bg-brand-900 text-white">
      <div className="absolute inset-0 bg-brand-mesh opacity-90" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-16 pb-20 sm:pt-24 sm:pb-24 text-center">
        <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold uppercase tracking-widest text-accent-300 mb-5 animate-fade-in-up">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400" />
          Built for Texas school districts
        </span>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold font-display leading-[1.05] max-w-4xl mx-auto animate-fade-in-up">
          Digital ticketing built for <span className="text-accent-400">school districts</span>.
        </h1>

        <p className="mt-5 text-lg sm:text-xl text-brand-100 max-w-2xl mx-auto animate-fade-in-up">
          One platform for athletics, fine arts, tournaments, and community events,
          loved by parents and trusted by athletic directors and superintendents.
        </p>

        {/* Explore Your District (primary) */}
        <div className="mt-9 animate-fade-in-up">
          <DistrictFinder variant="hero" />
        </div>

        {/* CTAs */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button to="/demo" variant="accent" size="lg" className="w-full sm:w-auto">
            Explore district demos →
          </Button>
          <Button onClick={onRequestDemo} variant="white" size="lg" className="w-full sm:w-auto">
            Request a demo
          </Button>
        </div>

        {/* Secondary: parent "Find Tickets" event search (always visible) */}
        <div id="find-tickets" className="mt-7 scroll-mt-20">
          <p className="text-sm text-brand-200 mb-2">🎟️ Buying tickets as a parent? Find your event:</p>
          <div className="max-w-xl mx-auto">
            <SearchBar />
          </div>
        </div>

        {/* Stat strip */}
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {STATS.map((s) => (
            <div key={s.label} className="rounded-2xl bg-white/10 backdrop-blur ring-1 ring-white/15 px-4 py-3">
              <p className="text-2xl sm:text-3xl font-bold font-display">{s.value}</p>
              <p className="text-xs text-brand-100 mt-0.5">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
